import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { appRoutes } from 'constants/appRoutes';
import { BsExclamationTriangleFill, BsX } from "react-icons/bs";
import { toast } from 'react-toastify';
import { apiUrls } from 'constants/apiUrls';
import { BsPersonFill } from "react-icons/bs";
import { BiPlus } from "react-icons/bi";
import { customerService } from 'services/customerService';
import { allowNumber } from 'utils/inputValidator';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { customerLabels, customerFields } from 'constants/customer';

const CustomerForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [isEditForm, setIsEditForm] = useState();
    const [message, setMessage] = useState();
    const [customer, setCustomer] = useState({
        name: '',
        address: '',
        mobileNo: '',
        email: '',
        hasGst: false,
        gstIn: '',
        isActive: true
    });

    useEffect(() => {
        setIsEditForm(() => (id ? true : false))

        if (id > 0) {
            setIsLoader(true);
            customerService.getCustomer(apiUrls.getCustomer(id)).then((res) => {
                setIsLoader(false);
                setCustomer(res)
            }).catch((err) => setIsLoader(false));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "mobileNo" && !allowNumber(e.target.value)) { return; }
        
        setCustomer((preValue) => ({
            ...preValue, [name]: (type === 'checkbox' ? checked : value)
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setIsLoader(true);
            if (isEditForm) {
                customerService.updateCustomer(apiUrls.updateCustomer(id), customer).then((res) => {
                    setIsLoader(false);
                    if (res === true) {
                        toast.info("Customer updated successfully!");
                        navigate(appRoutes.customers);
                    }
                }).catch((err) => setIsLoader(false));
            } else {
                customerService.addCustomer(apiUrls.addCustomer(), customer).then((res) => {
                    setIsLoader(false);
                    if (res === true) {
                        toast.info("Customer added successfully!");
                        navigate(appRoutes.customers);
                    }
                }).catch((err) => setIsLoader(false));
            }
        }
    }

    const validateForm = () => {
        setMessage();
        if (!customer.name
            || !customer.address
            || !customer.mobileNo) {
            setMessage("All star marked field required!");
            return false;
        }
        return true;
    }

    return (
        <>
            <Row className="justify-content-center">
                <Col md={6}>
                    <Card className='card-default'>
                        <Card.Body>
                            {isLoader && <ProgressLoader />}
                            <Card.Title>
                                <BsPersonFill size={24} /> {isEditForm ? 'Edit' : 'New'} {customerLabels.customer}
                            </Card.Title>
                            <Form onSubmit={handleSubmit} noValidate>
                                {message && (
                                    <Alert variant='danger'>
                                        <BsExclamationTriangleFill /> {message}
                                    </Alert>
                                )}
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">Name:*</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="text"
                                            maxLength={100}
                                            name='name'
                                            value={customer.name}
                                            onChange={handleChange}
                                            disabled={isEditForm} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">Address:*</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            maxLength={200}
                                            name='address'
                                            value={customer.address}
                                            onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">Mobile No:*</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="text"
                                            maxLength={10}
                                            name='mobileNo'
                                            value={customer.mobileNo}
                                            onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">Email:</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="email"
                                            maxLength={50}
                                            name='email'
                                            value={customer.email}
                                            onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">GSTIN</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="text"
                                            maxLength={20}
                                            name='gstIn'
                                            value={customer.gstIn}
                                            onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                {isEditForm && (
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">Active:</Form.Label>
                                        <Col sm="9">
                                            <Form.Check
                                                type="checkbox"
                                                name='isActive'
                                                checked={customer.isActive}
                                                onChange={handleChange}
                                                label="" />
                                        </Col>
                                    </Form.Group>
                                )}
                                <Form.Group as={Row}>
                                    <Col sm={{ span: 9, offset: 3 }}>
                                        <Button type="submit" variant='primary' className='mw-100'>
                                            <BiPlus size={20} /> {isEditForm ? 'Update' : 'Add'}
                                        </Button>
                                        <Button
                                            type="button"
                                            variant='secondary'
                                            className='ms-3 mw-100'
                                            onClick={() => navigate(appRoutes.customers)}>
                                            <BsX size={20} /> Cancel
                                        </Button>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default CustomerForm;